<div class="flex items-center justify-between">
  <h2 mat-dialog-title id="modal-basic-title">{{title()}}</h2>
  <button mat-button (click)="dialogRef.close(false)" style="padding: 1rem">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content>
  {{body()}}
</mat-dialog-content>
<mat-dialog-actions class="flex items-center justify-end">
  <button mat-flat-button color="primary" (click)="dialogRef.close(true)">Confirm</button>
  <button mat-flat-button color="warn" (click)="dialogRef.close(false)">Cancel</button>
</mat-dialog-actions>
